var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { QuestionComponent } from "../question/question.component";
import { MultipleChoiceQuestion } from 'app/shared/models/multiple-choice-question';
var QuestionDropdownComponent = /** @class */ (function (_super) {
    __extends(QuestionDropdownComponent, _super);
    function QuestionDropdownComponent() {
        return _super.call(this) || this;
    }
    QuestionDropdownComponent.prototype.ngOnInit = function () {
    };
    QuestionDropdownComponent.prototype.setAnswer = function (labelId) {
        var answer = this.labels.find(function (l) { return l.id == labelId; });
        this.question.setSavedAnswer(labelId, this.labels);
        this.notifyAnswered();
    };
    QuestionDropdownComponent.prototype.isSelected = function (label) {
        if (!(this.question instanceof MultipleChoiceQuestion)) {
            return false;
        }
        var mcQuestion = this.question;
        return mcQuestion.isAnswer(label);
    };
    return QuestionDropdownComponent;
}(QuestionComponent));
export { QuestionDropdownComponent };



// WEBPACK FOOTER //
// ./src/app/assessments/question-dropdown/question-dropdown.component.ts.pre-build-optimizer.js